<template>
  <div class="goodsFiles">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <div class="custom-date" v-if="searchType == 9">
            <div class="date-btn1" @click="showStartDate">
              <span v-if="searchForm.beginTime">{{ searchForm.beginTime }}</span>
              <span v-else>{{ $t.meta.beginDate }}</span>
            </div>
            <div class="date-btn2" @click="showEndDate">
              <span v-if="searchForm.endTime">{{ searchForm.endTime }}</span>
              <span v-else>{{ $t.meta.endDate }}</span>
            </div>
            <van-button size="small" type="info" @click="onSearch">{{
              $t.meta.search
            }}</van-button>
          </div>
          <van-field
            readonly
            :value="searchForm.cityName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showGoodsFilesCity')"
            v-else-if="searchType == 6 || searchType == 7"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="searchForm.businessTypeStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showGoodsFilesType')"
            v-else-if="searchType == 5"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.meta.searchText"
            v-else
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div @click="handleSheetShow">
            <span>{{ searchTypeStr }}</span>
          </div>
        </van-col>
      </van-row>
    </div>
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">{{ $t.goodsFiles.sopNumber }}：{{ item.SOPNumber }}</div>
        <div class="list-item">
          {{ $t.goodsFiles.sideWbNumber }}：{{ item.WB_Number }}
        </div>
        <div class="list-item">
          {{ $t.goodsFiles.companyNameSn }}：{{ item.CompanyNameSn }}
        </div>
        <div class="list-item">
          {{ $t.goodsFiles.businessType }}：{{ item.BusinessTypeStr }}
        </div>
        <div class="list-item">
          {{ $t.goodsFiles.deliveryCity }}：{{ item.DeliveryCountryCity }}
        </div>
        <div class="list-item">
          {{ $t.goodsFiles.destinationCity }}：{{ item.DestinationCountryCity }}
        </div>
        <div class="list-item">{{ $t.goodsFiles.createTime }}：{{ item.CreateTime }}</div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item.SOPId)"
            >{{ $t.meta.editButton }}</van-button
          >
        </div>
      </div>
    </van-list>

    <option-list
      event="showGoodsFilesType"
      :options="businessList"
      @onSelect="onSelectType"
    ></option-list>

    <option-list
      event="showGoodsFilesCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <van-action-sheet
      :title="$t.meta.searchType"
      :closeable="false"
      v-model="sheetShow"
      :actions="sheetActions"
      @select="sheetSelect"
    />

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
} from "vant";
import OptionList from "@components/optionList/OptionList.vue";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker);

export default {
  name: "goodsFiles",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      searchText: "",
      searchType: 1,
      searchTypeStr: this.$t.goodsFiles.sopNumber,
      tableData: [],
      cityList: [],
      businessList: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //搜索条件
      searchForm: {
        cityId: "",
        cityName: "",
        salesUserId: "",
        salesUserName: "",
        businessType: "",
        businessTypeStr: "",
        beginTime: "",
        endTime: "",
      },
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      //日期
      showStartPicker: false,
      showEndPicker: false,
      selectDate: new Date(),
      currentDate: "",
    };
  },
  created() {
    this.getCityList();
  },
  methods: {
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "goodsFilesDetail",
        name: "goodsFilesDetail",
        query: [
          {
            name: "SOPId",
            value: id,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.searchForm.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.searchForm.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    onSelectType(item) {
      this.searchForm.businessTypeStr = item.text;
      this.searchForm.businessType = item.value;
    },
    onSelectCity(item) {
      this.searchForm.cityName = item.text;
      this.searchForm.cityId = item.value;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    sheetSelect(e) {
      this.searchTypeStr = e.name;
      this.searchType = e.className;
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.goodsFiles.sopNumber, className: "1" },
        { name: this.$t.goodsFiles.sideWbNumber, className: "2" },
        { name: this.$t.goodsFiles.customerNumber, className: "3" },
        { name: this.$t.goodsFiles.companyNameSn, className: "4" },
        { name: this.$t.goodsFiles.businessType, className: "5" },
        { name: this.$t.goodsFiles.deliveryCity, className: "6" },
        { name: this.$t.goodsFiles.destinationCity, className: "7" },
        { name: this.$t.goodsFiles.erNumber, className: "8" },
        { name: this.$t.goodsFiles.date, className: "9" },
      ];
      this.businessList = [
        {
          text: this.$t.meta.wbType1,
          value: "1",
        },
        {
          text: this.$t.meta.wbType2,
          value: "2",
        },
        {
          text: this.$t.meta.wbType3,
          value: "3",
        },
        {
          text: this.$t.meta.wbType4,
          value: "4",
        },
        {
          text: this.$t.meta.wbType5,
          value: "5",
        },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
        SOPNumber: this.searchType == 1 ? this.searchText : "",
        WB_Number: this.searchType == 2 ? this.searchText : "",
        CustomerNumber: this.searchType == 3 ? this.searchText : "",
        CompanyName: this.searchType == 4 ? this.searchText : "",
        BusinessType: this.searchType == 5 ? this.searchForm.businessType : "",
        DeliveryCityId: this.searchType == 6 ? this.searchForm.cityId : "",
        DestinationCityId: this.searchType == 7 ? this.searchForm.cityId : "",
        OrderNumber: this.searchType == 8 ? this.searchText : "",
        BeginTime: this.searchType == 9 ? this.searchForm.beginTime : "",
        EndTime: this.searchType == 9 ? this.searchForm.endTime : "",
      };
      this.$api.logisticsManagement
        .getCargoFileCentersList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getCityList() {
      this.$api.logisticsManagement
        .getCountryList({
          type: 1,
        })
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.City_cn + "," + item.City_en,
              value: item.Id,
            };
            result.push(data);
          });
          this.cityList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";

.goodsFiles {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;

    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;

      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;

        .van-search__content {
          padding: 0px;
          margin-right: 10px;

          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }

        .van-cell {
          padding: 10px 0px 10px 20px;
        }

        .custom-date {
          padding: 10px 0px 10px 10px;

          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }

          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }

          .van-button {
            vertical-align: middle;
            width: 18%;

            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }

      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 12px;
      }
    }
  }

  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);

      .list-item {
        margin-bottom: 10px;
      }

      .buttons {
        text-align: right;

        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
